/*
 * Layout for mart transcript modal
 */

define([
  "marionette",
  "modules/learner/learnerTranscriptModal/template/learnerTranscriptModalTemplate.html",
], function (Marionette, LearnerTranscriptModalTemplate) {
  var LearnerTranscriptModalView = {};

  LearnerTranscriptModalView.learnerTranscriptModalLayout = Marionette.Layout.extend({
    template: LearnerTranscriptModalTemplate,
    events: {
      "change #transcriptStatus": function () {
        var optionSelected = this.$el.find("#transcriptStatus option:selected").val();
        this.trigger("change:status", optionSelected);
      },
    },
    regions: {
      conversation: "#conversationTranscript",
      conversationDetails: "#conversationTranscriptDetails",
      clusterChildren: "#clusterChildren",
    },
    triggers: {
      "click #deleteTranscript": "delete",
      "click #addToTopic": "add:to:topic",
      "click #createNewTopic": "create:new:topic",
    },
    disableLearnerFeatures: function (disabled) {
      if (disabled) {
        this.$el.find("#learnerModalControls").css("display", "none");
        var topicMatchLinks = this.$el.find("a#transcriptTopicMatch");
        topicMatchLinks.attr("data-topic-id", "tmlDisabled"); // topic match link disabled
        topicMatchLinks.addClass("tmlDisabled");
      }
    },
    setHighlightedTranscript: function (question, translatedQuestion) {
      if (translatedQuestion && translatedQuestion !== question) {
        this.$el
          .find(".transcript-quote span")
          .html(
            question.escapeHtml() +
              "<br><span class='translated-transcript-quote'>Translated to: " +
              translatedQuestion.escapeHtml() +
              "</span>",
          );
      } else {
        this.$el.find(".transcript-quote span").text(question);
      }
    },
  });

  return LearnerTranscriptModalView;
});
